import { Link, useMatchRoute } from "@tanstack/react-router"
import { LogOut, Settings, UserCog } from "lucide-react"
import {
  SidebarMenu,
  SidebarMenuAction,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/ui/components/ui/sidebar"
import { useLogout } from "@/auth"
import { LanguageSwitcher } from "@/profile"
import { useEffectiveTenantSlug } from "@/tenant"
import { useT } from "@/i18n"

export default function FooterMenu() {
  const { t } = useT()
  const tenantSlug = useEffectiveTenantSlug()
  const logout = useLogout()
  const matchRoute = useMatchRoute()
  const isSettingsActive = !!matchRoute({
    to: "/t/$tenantSlug/settings",
    fuzzy: true,
  })
  const isAccountActive =
    !!matchRoute({ to: "/t/$tenantSlug/account", fuzzy: true }) ||
    !!matchRoute({ to: "/account", fuzzy: true })

  return (
    <SidebarMenu>
      {tenantSlug && (
        <SidebarMenuItem>
          <SidebarMenuButton
            isActive={isSettingsActive}
            render={
              <Link to="/t/$tenantSlug/settings" params={{ tenantSlug }}>
                <Settings />
                {t("nav.settings")}
              </Link>
            }
          />
        </SidebarMenuItem>
      )}
      <SidebarMenuItem>
        <SidebarMenuButton
          isActive={isAccountActive}
          render={
            <Link
              to={tenantSlug ? "/t/$tenantSlug/account" : "/account"}
              params={tenantSlug ? { tenantSlug } : undefined}
            >
              <UserCog />
              {t("nav.account")}
            </Link>
          }
        />
        <SidebarMenuAction title={t("nav.logout")} onClick={logout}>
          <LogOut />
        </SidebarMenuAction>
      </SidebarMenuItem>
      <SidebarMenuItem className="group-data-[collapsible=icon]:hidden">
        <LanguageSwitcher align="start" />
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
